import React from 'react';
import { Page } from '../Page';
import { Brain, Zap, Moon } from 'lucide-react';
export function SupplementAshwagandha() {
  return <Page pageNumber={32} variant="light" data-id="element-3296" data-mp="3noss7szv9lp">
      <div className="flex h-full gap-10" data-id="element-3297" data-mp="3lrqff2zm7wud">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3298" data-mp="3ltt9pz7swc4w">
          <img src="https://cdn.magicpatterns.com/uploads/d3YyBiJkGkHonv19FV4VGU/pasted-image.png" alt="Thorne Ashwagandha" className="w-full max-w-[280px] object-contain" data-id="element-3299" data-mp="3ptu08i86cdsb" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3300" data-mp="8m02mijahk3x">
          <div className="mb-6 pt-4" data-id="element-3301" data-mp="8j44at3j4tey">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3302" data-mp="cma5vnfp5wf3">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3303" data-mp="10b363w3cqqfi">
              Ashwagandha
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3304" data-mp="154xjyiwa0b6o">
              Stress management for sustainable weight loss
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3305" data-mp="37e47xkfu2sg7" />
          </div>

          <div className="mb-8" data-id="element-3306" data-mp="3m2h2qe36q594">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3307" data-mp="3m2qtw4zyuige">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3308" data-mp="3v2nb5lk10f1f">
              Stress management is critical on GLP-1 medications. Elevated
              cortisol can drive cravings, disrupt sleep, and stall weight loss.
              Ashwagandha (Shoden® extract) directly supports the
              stress-sleep-energy triad that GLP-1 patients often struggle with.
              Just 1 capsule per day = simple compliance.
            </p>
          </div>

          <div className="mb-8" data-id="element-3309" data-mp="2anbvqxw0tkjp">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3310" data-mp="25npac161gxzt">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3311" data-mp="9kubmgvcz2z6">
              <li className="flex gap-2" data-id="element-3312" data-mp="9mx9fn2r60eg">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3313" data-mp="eivvh40lz6bp" />
                <span data-id="element-3314" data-mp="ilinp616yt9f">
                  Modulates cortisol and DHEA during times of stress, reducing
                  stress-driven eating
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3315" data-mp="nhzfca7lnpr9">
                <Moon className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3316" data-mp="sidmzr5agxor" />
                <span data-id="element-3317" data-mp="xi9sjutmwx6f">
                  Supports the sleep quality covered on your Sleep page, calming
                  without sedation
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3318" data-mp="12bm5v8sv5hjv">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3319" data-mp="169s57vrdguur" />
                <span data-id="element-3320" data-mp="1ba6gdmo9skx0">
                  Enhances daytime energy and mental clarity, resisting fatigue
                  during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3321" data-mp="1qcy3cj0ntyfc">
                <span className="text-tealslate shrink-0" data-id="element-3322" data-mp="1qdzdml9uqgw0">•</span>
                <span data-id="element-3323" data-mp="1le4nwl1tbxcj">
                  Shoden® extract at 35% withanolide glycosides, clinically
                  effective at smaller servings
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3324" data-mp="1cdyh1i0mdvmc">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3325" data-mp="1cezs3mhmyi42">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3326" data-mp="2924f1m31dprn">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3327" data-mp="246fkxy9sd12q">
                <strong data-id="element-3328" data-mp="1zcky4lyvw5zf">1 capsule daily</strong>. Can be taken morning or
                evening
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3329" data-mp="1vbj5inzh2s6f">
                30 capsules per bottle • Shoden® ashwagandha extract
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3330" data-mp="2n2oz0lkotrmq">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3331" data-mp="2n1xatvtf6w6h" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3332" data-mp="1yl0vku3vfy9e">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}